export default __webpack_public_path__ + "static/NEW_AboutSection_HomepageGraphic-01-cbe4e2cab46afc44100a64677ce1202d.png";